module.exports = __webpack_public_path__ + "static/image/logo-family/logo_mart@2x.png?12984d40";